import React, { useState } from "react";
import classnames from "classnames";
import Validator from "validator";
import { Stats } from "./Stats"
import { disableControlsByClass } from "./utils"
import isEmpty from "is-empty";

export const ProductsInterest = (props) => {

    const [errorProductosInteres, setErrorProductosInteres] = useState('')
    const errorProductosInteresOtros = '';
  
    const update = (e) => {
  
      const target = e.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      const id = target.id;
  
      if (target.type === 'checkbox') {
        if (validateSelection(e.target.className)) {
          props.update(id, value);
        }
      }
      else {
        props.update(id, value);
      }
    };
  
    const blur = (e) => {
      if (e.target.type === 'text') {
        if (validateSelection(e.target.className)) {
          props.update(e.target.id, e.target.value);
        }
      }
    };
  
    const submit = () => {
  
      let valid = true;
      let language = localStorage.getItem("exmi_language");

      setErrorProductosInteres("");
  
      // Intereses
      props.form.interesesAccesorios = !isEmpty(props.form.interesesAccesorios) ? props.form.interesesAccesorios : false;
      props.form.interesesCentrosEntretenimiento = !isEmpty(props.form.interesesCentrosEntretenimiento) ? props.form.interesesCentrosEntretenimiento : false;
      props.form.interesesCocinas = !isEmpty(props.form.interesesCocinas) ? props.form.interesesCocinas : false;
      props.form.interesesColchones = !isEmpty(props.form.interesesColchones) ? props.form.interesesColchones : false;
      props.form.interesesComedores = !isEmpty(props.form.interesesComedores) ? props.form.interesesComedores : false;
      props.form.interesesInfantilesJuveniles = !isEmpty(props.form.interesesInfantilesJuveniles) ? props.form.interesesInfantilesJuveniles : false;
      props.form.interesesMuebleOficina = !isEmpty(props.form.interesesMuebleOficina) ? props.form.interesesMuebleOficina : false;
      props.form.interesesRecamarasLiteras = !isEmpty(props.form.interesesRecamarasLiteras) ? props.form.interesesRecamarasLiteras : false;
      props.form.interesesServicios = !isEmpty(props.form.interesesServicios) ? props.form.interesesServicios : false;
      props.form.interesesTapizados = !isEmpty(props.form.interesesTapizados) ? props.form.interesesTapizados : false;
      props.form.interesesTerrazaJardin = !isEmpty(props.form.interesesTerrazaJardin) ? props.form.interesesTerrazaJardin : false;
      props.form.interesesTextiles = !isEmpty(props.form.interesesTextiles) ? props.form.interesesTextiles : false;
      props.form.interesesOtros = !isEmpty(props.form.interesesOtros) ? props.form.interesesOtros : "";
  
      props.form.interesesArteSacro = !isEmpty(props.form.interesesArteSacro) ? props.form.interesesArteSacro : false;
      props.form.interesesIluminacion = !isEmpty(props.form.interesesIluminacion) ? props.form.interesesIluminacion : false;
      props.form.interesesMecedoras = !isEmpty(props.form.interesesMecedoras) ? props.form.interesesMecedoras : false;
      props.form.interesesMesasCentroAuxiliares = !isEmpty(props.form.interesesMesasCentroAuxiliares) ? props.form.interesesMesasCentroAuxiliares : false;
      props.form.interesesLiterasMadera = !isEmpty(props.form.interesesLiterasMadera) ? props.form.interesesLiterasMadera : false;
      props.form.interesesTapetes = !isEmpty(props.form.interesesTapetes) ? props.form.interesesTapetes : false;
  
      if (!props.form.interesesAccesorios &&
        !props.form.interesesCentrosEntretenimiento &&
        !props.form.interesesCocinas &&
        !props.form.interesesColchones &&
        !props.form.interesesComedores &&
        !props.form.interesesInfantilesJuveniles &&
        !props.form.interesesMuebleOficina &&
        !props.form.interesesRecamarasLiteras &&
        !props.form.interesesServicios &&
        !props.form.interesesTapizados &&
        !props.form.interesesTerrazaJardin &&
        !props.form.interesesTextiles &&
        !props.form.interesesArteSacro &&
        !props.form.interesesIluminacion &&
        !props.form.interesesMecedoras &&
        !props.form.interesesMesasCentroAuxiliares &&
        !props.form.interesesLiterasMadera &&
        !props.form.interesesTapetes &&
        Validator.isEmpty(props.form.interesesOtros)
      ) {
        if (language === "es") {
          setErrorProductosInteres("Debe seleccionar al menos un producto de interes");
        }
        else {
          setErrorProductosInteres("You must select at least one product of interest");
        }
  
        valid = false;
      }
  
      if (valid)
        props.submit();
  
    };
  
    const validateSelection = (category) => {
      if (category === "ProductosInteres") {
        return disableControlsByClass(category, 5);
      }
      return true;
    };
  
  
    return (
      <div>
        <div className="col s12" style={{ paddingLeft: "11.250px" }}>
          <h4>
            <b>{props.locale.dashboard_comprador_label_interest_title}</b>
          </h4>
        </div>
        <div className="ProductosInteresParent">
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_accesories}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesAccesorios" onChange={update} checked={props.form.interesesAccesorios} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_religiousart}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesArteSacro" onChange={update} checked={props.form.interesesArteSacro} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_entertaimentcenters}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesCentrosEntretenimiento" onChange={update} checked={props.form.interesesCentrosEntretenimiento} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_kitchen}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesCocinas" onChange={update} checked={props.form.interesesCocinas} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_mattresses}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesColchones" onChange={update} checked={props.form.interesesColchones} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_dinning}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesComedores" onChange={update} checked={props.form.interesesComedores} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_lighting}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesIluminacion" onChange={update} checked={props.form.interesesIluminacion} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_rocking_chairs}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesMecedoras" onChange={update} checked={props.form.interesesMecedoras} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_side_tables}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesMesasCentroAuxiliares" onChange={update} checked={props.form.interesesMesasCentroAuxiliares} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_children}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesInfantilesJuveniles" onChange={update} checked={props.form.interesesInfantilesJuveniles} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_office}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesMuebleOficina" onChange={update} checked={props.form.interesesMuebleOficina} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_bedroom}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesRecamarasLiteras" onChange={update} checked={props.form.interesesRecamarasLiteras} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_wooden_bunk_beds}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesLiterasMadera" onChange={update} checked={props.form.interesesLiterasMadera} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_services}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesServicios" onChange={update} checked={props.form.interesesServicios} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_outdoor}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesTerrazaJardin" onChange={update} checked={props.form.interesesTerrazaJardin} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_upholstery}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesTapizados" onChange={update} checked={props.form.interesesTapizados} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_textil}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesTextiles" onChange={update} checked={props.form.interesesTextiles} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
          <div className="ProductosInteresChild">
            <div className="input-field col s8">{props.locale.dashboard_comprador_label_rugs}</div>
            <div className="input-field col s4">
              <div className="switch">
                <label>
                  <input type="checkbox" id="interesesTapetes" onChange={update} checked={props.form.interesesTapetes} className="ProductosInteres" />
                  <span className="lever"></span>
                </label>
              </div>
            </div>
          </div>
  
        </div>
  
        <div className="input-field col s12">
          <input
            onChange={update}
            onBlur={blur}
            value={props.form.interesesOtros}
            error={errorProductosInteresOtros}
            id="interesesOtros"
            type="text"
             className={classnames("font-face-msb", {
              invalid: errorProductosInteresOtros
            }, "ProductosInteres")}
          />
          <label htmlFor="interesesOtros">{props.locale.dashboard_comprador_label_others}</label>
          <span className="red-text">{errorProductosInteresOtros}</span>
        </div>
        <div className="input-field col s12"><span className="red-text">{errorProductosInteres}</span></div>
  
        <div className="col s12">
          <label>{props.locale.dashboard_comprador_label_advice}</label>
          <a href={props.locale.dashboard_comprador_label_privacy_url} target="_blank" rel="noopener noreferrer">{props.locale.dashboard_comprador_label_privacy}</a>
        </div>
        <Stats step={5} {...props} nextStep={submit}  vip={props.form.vip} />
      </div>
    );
  };